import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import useSocialCallbackHandler from './use-social-callback-handler';

type Parameters = {
  connectorId: string;
};

/**
 * UI-free callback entry for social sign-in and single sign-on.
 *
 * This path is kept as the registered provider redirect URI. It immediately
 * forwards the provider response to the connector-specific verification route
 * without rendering a loading page in between.
 */
const Callback = () => {
  const { connectorId } = useParams<Parameters>();

  const { socialCallbackHandler } = useSocialCallbackHandler();

  // SocialSignIn Callback Handler
  useEffect(() => {
    if (!connectorId) {
      return;
    }
    socialCallbackHandler(connectorId);
  }, [socialCallbackHandler, connectorId]);

  return null;
};

export default Callback;
